
import { TScheduler, TSpecialEvent } from "../types";
import { CalendarRefListItem } from "./CalendarRefListItem";
import { DateListItem } from "./DateListItem";

export const ExceptionsListItem = (props: { app: TScheduler,  item: TSpecialEvent }) => {
    const { item, app } = props;
 
    if (item.calendarReference ) {
      return <CalendarRefListItem app={app} eventPriority={item.eventPriority} period={item.calendarReference}></CalendarRefListItem>
    }
  
    else if (item.calendarEntry ) {
      return <DateListItem eventPriority={item.eventPriority} period={item.calendarEntry}></DateListItem>
    }
  
    return (<>unsupported type</>)
  }
  